import { ChangeEvent, FC, Fragment } from "react";
import {
  Box,
  Button,
  IconButton,
  InputAdornment,
  Link,
  TextField,
  Tooltip,
} from "@mui/material";
import { Visibility, VisibilityOff } from "@mui/icons-material";
import { InputDataType } from "../../../DataTypes/Form";
import { CheckStringEmpty } from "Utils/Common";
import { InputImgSwitch } from "Utils/SwitchCases";
// import { Link } from "react-router-dom";

const InputField: FC<InputDataType> = (props: InputDataType) => {
  const {
    id,
    label,
    placeholder,
    type,
    acceptFileTypes,
    value,
    error,
    errorText,
    onChange,
    required,
    multiline,
    readOnly,
    multilineRows,
    handleEnter,
    onBlurChange,
    onFocusChange,
    minVal,
    maxVal,
    borderColor,
    focused,
    iconId,
    infoText,
    iconClickHandler,
    hasPasswordToggle,
    showPassword,
    onPasswordToggle,
  } = props;

  return (
    <Fragment>
      <TextField
        margin="normal"
        fullWidth
        name={id}
        label={label}
        required={required ? true : false}
        {...(handleEnter && { onKeyDown: (e) => handleEnter(e) })}
        {...(borderColor && { color: borderColor })}
        {...(placeholder && { placeholder: placeholder })}
        {...(onChange && {
          onChange: (event: ChangeEvent<HTMLInputElement>) => {
            onChange(
              type === "file"
                ? event.target.files
                  ? Array.from(event.target.files)
                  : []
                : event.target.value
            );
          },
        })}
        {...(focused && { focused: true })}
        inputProps={{
          ...(type === "file" && {
            accept: acceptFileTypes ? acceptFileTypes : 
              "image/png, image/svg, image/jpg, image/jpeg application/pdf",
            multiple: true,
          }),
          ...(minVal && { min: minVal }),
          ...(maxVal && { max: maxVal }),
        }}
        {...(onBlurChange && { onBlur: (e) => onBlurChange(e.target.value) })}
        {...(onFocusChange && {
          onFocus: (e) => onFocusChange(e.target.value),
        })}
        multiline={multiline ? multiline : false}
        disabled={readOnly ? readOnly : false}
        {...(value !== undefined && { value: value })}
        {...(type && { type: type })}
        {...(multilineRows && { rows: multilineRows })}
        {...(errorText && { helperText: errorText })}
        error={error ? error : false}
        slotProps={{
          input: {
            ...{
              endAdornment: (() => {
                // Password toggle takes priority
                if (hasPasswordToggle && onPasswordToggle) {
                  return (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={onPasswordToggle}
                        edge="end"
                        aria-label="toggle password visibility"
                        sx={{
                          p: 1,
                          '&:hover': {
                            backgroundColor: 'rgba(0, 0, 0, 0.04)',
                          }
                        }}
                      >
                        {showPassword ? <VisibilityOff /> : <Visibility />}
                      </IconButton>
                    </InputAdornment>
                  );
                }

                // Regular icon handling
                if (iconId) {
                  if (iconClickHandler) {
                    return (
                      <IconButton
                        onClick={() => iconClickHandler(id)}
                        sx={{ p: 0 }}
                      >
                        <InputAdornment position="end">
                          {InputImgSwitch(iconId)}
                        </InputAdornment>
                      </IconButton>
                    );
                  } else if (CheckStringEmpty(infoText)) {
                    return (
                      <InputAdornment position="end" sx={{ cursor: "pointer" }}>
                        <Tooltip title={infoText} arrow>
                          {InputImgSwitch(iconId)}
                        </Tooltip>
                      </InputAdornment>
                    );
                  } else {
                    return (
                      <InputAdornment position="end">
                        {InputImgSwitch(iconId)}
                      </InputAdornment>
                    );
                  }
                }

                return null;
              })(),
            },
          },
        }}
      />
    </Fragment>
  );
};
export default InputField;
